import { Center, Spinner } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';

import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import ProfileLoadedContainer from 'presentation/containers/modules/profile/ProfileLoadedContainer';
import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import { Helmet } from 'react-helmet-async';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';

const ProfilePage: FC = () => {
  const { data, isFetching, error, refetch } = useFetchProfileQuery();

  const { t } = useTranslation();

  let content;
  if (isFetching) {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  } else if (data) {
    content = <ProfileLoadedContainer data={data} />;
  } else if (error) {
    content = (
      <Center>
        <ErrorContainer
          error={error}
          onRetry={() => {
            refetch();
          }}
        />
      </Center>
    );
  } else {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  }

  return (
    <SettingsLayout>
      <Helmet>
        <title>{t('profileLabel')}</title>
      </Helmet>
      <GridHeading>{t('profileLabel')}</GridHeading>
      <AppCard w="100%" p="40px">
        {content}
      </AppCard>
    </SettingsLayout>
  );
};

export default ProfilePage;
